import { handleActions } from 'redux-actions'

const initialState = {
  isMobile: false
}

const reducerMap = {
  SERVICE_SET_REQUEST: (state, action) => ({
    ...state,
    isMobile: action.payload.ecdevice.isMobile
  })
}

/// In most case handleActions can handle everything
/// https://github.com/acdlite/redux-actions#handleactionsreducermap-defaultstate
/// You should export one reducer function as default
export default handleActions(reducerMap, initialState)
